import { Injectable } from '@angular/core';

/**
 * Código de verificación del flujo "olvidé mi contraseña", solo en memoria.
 *
 * El paso de verificar el código lo deja aquí y el de cambiar la contraseña lo
 * reenvía al servidor. Antes iba en sessionStorage, donde cualquier script del
 * origen podía leerlo mientras la pestaña siguiera abierta. Si se recarga la
 * página se pierde y hay que verificar el código otra vez.
 */
@Injectable({ providedIn: 'root' })
export class PasswordResetFlowService {
  private code: string | null = null;

  setCode(code: string): void {
    this.code = code;
  }

  getCode(): string | null {
    return this.code;
  }

  clear(): void {
    this.code = null;
  }
}
